<div class="home scroll-hidden">
  <!-- ── Hero ──────────────────────────────────────────────────────────────── -->
  <div class="home__hero">
    <div class="home__aurora" aria-hidden="true">
      <aurora-light
        [colorStops]="['#54c4ed', '#a4d165', '#54c4ed']"
        [amplitude]="1.4"
        [blend]="0.5"
        [speed]="2.2"
        [opacity]="0.7"
      />
    </div>

    <sphere-animation />

    <div class="home__inner">
      <greeting />

      <div class="home__search-wrap">
        <chat-prompt placeholder="" (submit)="initiateNewChat($event)" [(text)]="userInput">
          <div slot="placeholder" class="home__search-ph" aria-hidden="true">
            <span class="home__search-ph-static">Search for</span>
            <span class="home__search-ph-clip">
              @if (phTransitioning()) {
                <span class="home__search-ph-word home__search-ph-word--exit">{{
                  phSuggestions[phPrev()]
                }}</span>
                <span class="home__search-ph-word home__search-ph-word--enter">{{
                  phSuggestions[phIndex()]
                }}</span>
              } @else {
                <span class="home__search-ph-word">{{ phSuggestions[phIndex()] }}</span>
              }
            </span>
          </div>
        </chat-prompt>
      </div>

      <!-- ── Suggested Prompts ── -->
      <div class="home__prompts">
        <span class="home__prompts-label">Ideas to get started:</span>
        <div class="home__prompts-chips">
          @for (cat of promptCategories; track cat.label) {
            <button
              class="home__prompt-chip"
              [class.home__prompt-chip--active]="activePromptCategory() === cat.label"
              (click)="togglePromptCategory(cat.label, $event)"
            >
              {{ cat.label }}
              <svg
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                [style.transform]="
                  activePromptCategory() === cat.label ? 'rotate(180deg)' : 'rotate(0deg)'
                "
                style="transition: transform 0.18s ease; flex-shrink: 0"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  @if (activePromptCategory() && dropdownPos()) {
    <!-- Stop propagation here seems to be preventing the popover from closing
    if the part of the div is clicked that isn't an option? Was LLM generated. -->
    <div
      class="home__prompts-dropdown"
      [style.top.px]="dropdownPos()!.top"
      [style.left.px]="dropdownPos()!.left"
      [style.width.px]="dropdownPos()!.width"
      (click)="$event.stopPropagation()"
    >
      @for (cat of promptCategories; track cat.label) {
        @if (cat.label === activePromptCategory()) {
          @for (prompt of cat.prompts; track prompt) {
            <button class="home__prompt-item" (click)="applyPrompt(prompt)">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="flex-shrink: 0"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              {{ prompt }}
            </button>
          }
        }
      }
    </div>
  }

  <!-- ── Content ────────────────────────────────────────────────────────────── -->
  <div class="home__body">
    <div class="home__inner">
      <!-- Bookmarks -->
      <recent-bookmarks />

      <!-- Have something to share (bottom, full-width) -->
      <div class="home__cta-banner" style="margin-top: 40px">
        <div class="home__cta-text">
          <strong class="home__cta-title">Have something to share?</strong>
          <p class="home__cta-desc">
            Contribute your data collections, tools, or agents to help ADB work smarter together.
          </p>
        </div>
        <contribute-asset-button />
      </div>
    </div>
  </div>
</div>
